import React from 'react';
import { Factory, Home, Wrench, ClipboardList, Package, Settings } from 'lucide-react';
import { services } from '../mockData';

const Services = () => {
  const getIcon = (iconName) => {
    const icons = {
      factory: Factory,
      home: Home,
      wrench: Wrench,
      'clipboard-list': ClipboardList,
      package: Package,
      settings: Settings
    };
    const Icon = icons[iconName];
    return Icon ? <Icon size={40} /> : null;
  };

  return (
    <section id="servicios" className="section services-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Nuestros Servicios</h2>
          <p className="section-description">
            Ofrecemos una amplia gama de servicios especializados en filtración para satisfacer todas sus necesidades
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">
                {getIcon(service.icon)}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, index) => (
                  <li key={index} className="service-feature">{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
